<template>
	<UiElement class="d-flex flex-column h-100 pb-0" :settings="appearance.body.settings">
		<div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
			<UiText :settings="heading1" class="text-center">
				{{ translations?.paymentFailed || '{paymentFailed}' }}
			</UiText>

			<UiText :settings="heading2" class="text-center my-5">
				{{ translations?.paymentFailedTitle || '{paymentFailedTitle}' }}
			</UiText>

			<div class="d-flex flex-column gap-5">
				<UiButton :settings="button1">
					{{ translations?.tryAgain || '{tryAgain}' }}
				</UiButton>

				<UiButton :settings="button2">
					{{ translations?.cancel || '{cancel}' }}
				</UiButton>
			</div>
		</div>
	</UiElement>
</template>

<script setup>
	import { computed } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);

	const page = computed(() => theme.value.pages.paymentFailed);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const heading2 = useInheritedSettings(computed(() => elements.value?.heading2));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));
</script>